import React from 'react';
import { motion } from 'framer-motion';
export function ForWho() {
  return <section className="for-who" data-id="element-69">
      <motion.div className="container" initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-40px'
    }} transition={{
      duration: 0.8
    }} data-id="element-70">
        <span className="section-tag" data-id="element-71">¿Es para ti?</span>
        <h2 data-id="element-72">Este workshop es para ti si…</h2>
        <p data-id="element-73">
          Eres coach, freelancer, tienes un negocio de servicios, vendes
          productos, o estás empezando un emprendimiento — y necesitas una
          página web profesional{' '}
          <strong data-id="element-74">sin gastar miles de dólares ni esperar meses.</strong>
        </p>
        <p data-id="element-75">
          Quieres aprender a hacerlo tú para no depender de nadie y tener el
          control de tu presencia online.
        </p>
        <p className="note" data-id="element-76">
          No necesitas saber de tecnología, diseño ni código. Solo una
          computadora y 2 horas.
        </p>
      </motion.div>
    </section>;
}